import { connect } from "react-redux";
import { useQuery } from "@apollo/client";

import { IAppState, IOrganizationParams } from "../../interfaces/interfaces";
import { ReactComponent as CloseIcon } from "../../img/Close.svg";
import { ReactComponent as Envelope } from "../../img/Envelope.svg";
import { GET_ORGANIZATION } from "../../api/gqlQueries";

import InviteManagerForm from "./InviteManagerForm";

interface IOrganizationData {
  organization: {
    name: string;
  };
}

const InviteManagerModal: React.FC<{
  closeModalFn: () => void;
  refetch: () => void;
  organizationId: string;
}> = ({ closeModalFn, refetch, organizationId }) => {
  const { loading, data } = useQuery<IOrganizationData, IOrganizationParams>(
    GET_ORGANIZATION,
    { variables: { organizationId } }
  );
  if (loading) return null;
  if (!data) throw Error("No data was returned");

  return (
    <div className="popup-background">
      <div className="invite-manager-modal">
        <div className="invite-manager-modal-header">
          <div className="center-align-as-row">
            <Envelope
              title="Invite Manager"
              className="invite-manager-modal-icon"
            />
            <div className="invite-manager-modal-title">Invite an Admin</div>
          </div>
          <CloseIcon
            onClick={closeModalFn}
            className="changes-header-img"
            title="Close modal"
          />
        </div>
        <div className="invite-manager-modal-body">
          <div className="invite-manager-modal-section">
            <p>
              Please provide an e-mail of the admin you would like to add to the
              organization <b>{data.organization.name}</b>. The invite will
              remain active for 24 hours.
            </p>
            <br />
            <p>
              Admins are able to manage the homes that are part of the{" "}
              <b>{data.organization.name}</b> organization. Admins can also
              invite or remove other admins within the organization.
            </p>
          </div>
          <div className="invite-manager-modal-heading">Invite Details</div>
          <InviteManagerForm
            closeModalFn={closeModalFn}
            refetch={refetch}
            organizationId={organizationId}
          />
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state: IAppState) => {
  return { user: state.user };
};
export default connect(mapStateToProps)(InviteManagerModal);
